import SettingsPage from './components/SettingsPage';

const routes = [
  {
    path: '/settings',
    name: 'menu.settings',
    className: 'menu-settings',
    icon: 'settings',
    customIcon: true,
    loginRequired: true,
    component: SettingsPage,
    weight: 1,
    permission: ['settings'],
    children: [],
  },
];

export default routes;
